<template>
	<el-dialog
		title="登录验证设置"
		:visible.sync="dialogVisible"
		width="400px"
		@close="reset"
	>
		<div class="item_box" style="padding: 0 20px">
			<div>选择登录验证方式：</div>
			<div style="color: red; font-size: 12px;">登录验证当前仅对品牌管理员开放</div>
			<el-checkbox-group v-model="checkList">
				<el-checkbox label="sms">短信</el-checkbox>
				<el-checkbox label="email">邮件</el-checkbox>
			</el-checkbox-group>
			<div>密码历史验证：</div>
			<el-radio-group v-model="isHistValid">
				<el-radio label="1">是</el-radio>
				<el-radio label="0">否</el-radio>
			</el-radio-group>
			<div>60天修改密码：</div>
			<el-radio-group v-model="isExpireValid">
				<el-radio label="1">是</el-radio>
				<el-radio label="0">否</el-radio>
			</el-radio-group>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false" size="mini"
				>取 消</el-button
			>
			<el-button
				type="primary"
				@click="commit"
				size="mini"
				:loading="loading"
				>确 定</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			dialogVisible: false,
			checkList: [],
			isHistValid: "",
			isExpireValid: "",
		};
	},
	methods: {
		open(row) {
			this.brandId = row.brandId;
			this.brandIdentify = row.brandIdentify;
			this.checkList = row.secverifyType
				? row.secverifyType.split(",")
				: [];
			this.isHistValid = row.isHistValid ?? "";
			this.isExpireValid = row.isExpireValid ?? "";
			this.dialogVisible = true;
		},
		commit() {
			this.loading = true;
			this.$api
				.getBrandSaves("update", {
					brandId: this.brandId,
					brandIdentify: this.brandIdentify,
					secverifyType: this.checkList.join(","),
					isHistValid: this.isHistValid,
					isExpireValid: this.isExpireValid,
				})
				.then((res) => {
					if (res && res.errcode != 0) return false;
					this.$store.dispatch("user/getInfo").then((response) => {});
					this.$message.success("设置成功!");
					this.$emit("handleDone");
					this.dialogVisible = false;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		reset() {
			Object.assign(this.$data, this.$options.data.call(this));
		},
	},
};
</script>

<style lang="scss" scoped>
.item_box {
	& > div {
		margin: 10px;
	}
}
</style>